import React, {Component} from "react"
import PropTypes from "prop-types"

import {Item, List, Wrapper} from "./styled"
import {TextButton} from "../Button"

import {DEFAULT_MAX_SEARCH_RESULTS, EMOJI} from "./constants"
import {emojiSearch, isLastCharEqualToFirstChar, PickerTitle} from "./"

class EmojiSearchPicker extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    stringToReplace: PropTypes.shape({
      fullString: PropTypes.string.isRequired,
      reducedString: PropTypes.string.isRequired
    }).isRequired
  }

  componentDidUpdate() {
    const {onSelect, stringToReplace} = this.props
    if (isLastCharEqualToFirstChar(stringToReplace.fullString)) {
      const searchResults = emojiSearch(stringToReplace.reducedString)

      if (searchResults.length > 0) {
        onSelect({
          stringToAppend: searchResults[0].native,
          ...stringToReplace
        })
      }
    }
  }

  render() {
    const {onSelect, stringToReplace} = this.props
    const searchResults = emojiSearch(stringToReplace.reducedString)

    return (
      <Wrapper>
        <PickerTitle titleValue={stringToReplace.fullString} type={EMOJI} />
        <List>
          {searchResults.slice(0, DEFAULT_MAX_SEARCH_RESULTS).map((o, i) => (
            <TextButton
              key={i}
              onClick={() =>
                onSelect({
                  stringToAppend: o.native,
                  ...stringToReplace
                })
              }>
              <Item>
                {o.native} :{o.id}
              </Item>
            </TextButton>
          ))}
        </List>
      </Wrapper>
    )
  }
}

export default EmojiSearchPicker
